import { column, Css, GridColumn, GridTableLayout, simpleDataRows, SimpleHeaderAndData } from "@homebound/beam";
import { useMemo } from "react";
import { dateCell, emptyCellDash } from "src/components";
import { signedCount } from "src/utils";
import { ReviewProjectImpact_MilestoneScheduleImpactFragment } from "../3.ReviewImpactStep.generated";

type ScheduleImpactTableProps = {
  /** Only the milestones the configuration moves, already sorted by the backend. */
  milestones: ReviewProjectImpact_MilestoneScheduleImpactFragment[];
};

export function ScheduleImpactTable(props: ScheduleImpactTableProps) {
  const { milestones } = props;
  const rows = useMemo(
    () => simpleDataRows(milestones.map((m) => ({ ...m, id: m.globalPlanMilestone.id }))),
    [milestones],
  );
  const columns = useMemo(() => createColumns(), []);

  return <GridTableLayout tableProps={{ id: "scheduleImpactTable", rows, columns }} hideEditColumns />;
}

type ScheduleImpactRow = ReviewProjectImpact_MilestoneScheduleImpactFragment & { id: string };
type Row = SimpleHeaderAndData<ScheduleImpactRow>;

function createColumns(): GridColumn<Row>[] {
  return [
    column<Row>({ header: "Milestone", data: ({ globalPlanMilestone }) => globalPlanMilestone.name, w: 2 }),
    column<Row>({ header: "Current Finish", data: ({ currentFinishDate }) => dateCell(currentFinishDate) }),
    column<Row>({ header: "Proposed Finish", data: ({ proposedFinishDate }) => dateCell(proposedFinishDate) }),
    column<Row>({
      header: "Change",
      data: ({ changeInDays }) => {
        if (!changeInDays) return emptyCellDash;
        return <span css={Css.if(changeInDays > 0).red600.else.green600.$}>{signedCount(changeInDays, "day")}</span>;
      },
    }),
  ];
}
